import BaseViewController from "./base-view-controller";

class BhIntakeViewController extends BaseViewController {}

export default BhIntakeViewController;
